import React from 'react';

import { useAppSelector } from '../../../../components/hooks';
import { getVisibleRoofContainers } from '../../../../store/selectors/layoutDataSelectors';
import { SingleRoofContainerRunDimensionsController } from './SingleRoofContainerRunDimensionsController';

export function RoofContainersRunDimensionsController() {
  const roofContainers = useAppSelector(getVisibleRoofContainers);

  if (roofContainers.length === 0) return null;

  return roofContainers.map((container) => (
    <SingleRoofContainerRunDimensionsController key={container.guid} roofContainer={container} />
  ));
}
